import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enJs from "./en.js";

const resources = {
  en: {
    translation: enJs,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
